import React from "react";

import Valucadi_image1 from "../../assets/Valucadi_image1.jpg"

export const Image1 = () => {
    return (
      <img
        src={Valucadi_image1}
        alt="Valucadi 1 Sales rep and Blindfolded Golfer"
        style={{ width: "100%", height: "auto" }}
      />
    );
  };